import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../components/helpers/LazyAction'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useGroupsState = () => React.useContext(Context) || {}
export const useGroups = () => useGroupsState()?.userGroups || []

const QUERY = gql`
  query UserGroups($page: Int, $search: String, $filter: UserGroupFilter) {
    userGroups(page: $page, search: $search, filter: $filter, sort: { field: ID, type: ASC }) {
      id
      name
    }
  }
`

const GroupsLoader = ({ children, search, uncontrolledChildren, perPage: limit, filter }) => {
  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search: search || undefined,
      limit,
      filter
    },
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default GroupsLoader
